import React from 'react';
import { MediaSupport } from "../view-model";
export const useMediaSupport = check => {
  const mediaDevices = React.useMemo(() => Boolean(navigator.mediaDevices), []);
  const enumerateMedia = React.useMemo(() => Boolean(mediaDevices && navigator.mediaDevices.enumerateDevices), []);
  const userMedia = React.useMemo(() => Boolean(mediaDevices && navigator.mediaDevices.getUserMedia), []);
  // @ts-ignore
  const displayMedia = React.useMemo(() => Boolean(mediaDevices && navigator.mediaDevices.getDisplayMedia), []);
  const support = React.useCallback(() => {
    switch (check) {
      case MediaSupport.MEDIA_DEVICES:
        return mediaDevices;
      case MediaSupport.ENUMERATE_MEDIA:
        return enumerateMedia;
      case MediaSupport.USER_MEDIA:
        return userMedia;
      case MediaSupport.DISPLAY_MEDIA:
        return displayMedia;
      default:
        return false;
    }
  }, [check]);
  return support();
};